import Page from "../../components/Page"
import ClaimVotingRewardForm from "../../forms/ClaimVotingRewardForm"

const ClaimVotingReward = () => (
  <Page>
    <ClaimVotingRewardForm />
  </Page>
)

export default ClaimVotingReward
